// src/lib/toast.ts
// Minimal, dependency-free toast system — a plain module-level pub/sub
// rather than a library, since this is the only global notification
// need so far. Triggered from React Query's global mutation error
// handler (main.tsx) for rate-limit (429) responses specifically
// (design confirmed 2026-07-16), but usable for anything else that
// needs a brief, app-wide notice later.
type ToastListener = (message: string) => void;
const listeners = new Set<ToastListener>();

export function showToast(message: string) {
  listeners.forEach((l) => l(message));
}

export function subscribeToToasts(listener: ToastListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
